module.exports = "/assets/js/e06594ffda93b3f139453f2ca65a4f88.svg";